import { CSP_NONCE, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
import { ToastsContainerModule } from './services/toast/toasts.module';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatStepperModule } from '@angular/material/stepper';
import { OutgoingInterceptor } from './router/interceptors/outgoing.interceptor';
import { AuthInterceptor } from './router/interceptors/auth.interceptor';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { WorkflowComponent } from './components/workflow/workflow.component';
import { LicenseLockedComponent } from './components/license-locked/license-locked.component';

// Helper function to read the CSP nonce from the meta tag injected by the server
function getNonceFromMeta(): string | null {
  if (typeof document !== 'undefined') {
    const metaTag = document.querySelector('meta[name="csp-nonce"]');
    return metaTag ? metaTag.getAttribute('content') : null;
  }
  return null;
}

@NgModule({
  declarations: [AppComponent, WorkflowComponent, LicenseLockedComponent],
  imports: [BrowserModule, BrowserAnimationsModule, AppRoutingModule, HttpClientModule, NgbModule, ReactiveFormsModule, ToastsContainerModule, ToastrModule.forRoot({ preventDuplicates: true }), MatStepperModule, NoopAnimationsModule],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: OutgoingInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: CSP_NONCE, useFactory: getNonceFromMeta }
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
